'use strict';

module.exports = function(angularModule) {

  angularModule.controller("MessageQuotaWarningConfigModalController",
    function ($scope, $uibModalInstance, RGSenderConfigService) {
      RGSenderConfigService.getConfig().then(function(config) {
        $scope.warningThreshold = config.messageQuotaWarningConfig.warningThreshold
        $scope.sendEmailNotifications = config.messageQuotaWarningConfig.sendEmailNotifications
      })

      $scope.close = function () {
        $uibModalInstance.dismiss('cancel');
      };

      $scope.updateWarningConfig = function(validationResult) {
        $scope.configUpdating = true
        RGSenderConfigService
          .updateMessageWarningConfig($scope.warningThreshold, $scope.sendEmailNotifications)
          .then(function(config) {
            $scope.warningThreshold = config.messageQuotaWarningConfig.warningThreshold
            $scope.sendEmailNotifications = config.messageQuotaWarningConfig.sendEmailNotifications
            $scope.configUpdating = false
            $scope.close()
          })
      }
    });
};